import { object, string } from "yup";

export const validateMoveOutDate = object({
  moved_out_date: string().required("Move out date is required")
});
